"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDynamicFilters = buildDynamicFilters;
const mapDynamicFilters_1 = require("./mapDynamicFilters");
function buildDynamicFilters(builder, filterPanelLabel, dynamicColumnData) {
    if (dynamicColumnData) {
        const columnDefs = dynamicColumnData.columnDefs.filter((columnDef) => columnDef.metadata?.showInFilters);
        if (columnDefs.length > 0) {
            const children = [];
            for (const columnDef of columnDefs) {
                const key = `_dynamic_${columnDef.name}`;
                const label = columnDef.metadata?.label ?? '';
                const values = (0, mapDynamicFilters_1.mapHandlerToValues)(dynamicColumnData.handlerMap.get(columnDef.metadata?.columnHandlerName ?? ''));
                switch (columnDef.type) {
                    case 'boolean':
                        children.push(builder.allFiltersWidget({
                            type: 'form.checkbox',
                            key,
                            label,
                        }));
                        break;
                    case 'number':
                        // interesting "if", is there a better way?
                        if (columnDef.metadata?.columnHandlerName.toLowerCase().includes('date')) {
                            children.push({
                                type: 'form.panel',
                                children: [
                                    builder.allFiltersWidget({
                                        type: 'form.datePicker',
                                        key: key + '_after',
                                        label: label + ' After',
                                    }),
                                    builder.allFiltersWidget({
                                        type: 'form.datePicker',
                                        key: key + '_before',
                                        label: label + ' Before',
                                    }),
                                ],
                                style: { layout: 'row' },
                            });
                        }
                        else if (values) {
                            children.push(builder.allFiltersWidget(filterWithValues(key, label, values)));
                        }
                        else {
                            children.push(builder.allFiltersWidget({
                                type: 'form.number',
                                key,
                                label,
                            }));
                        }
                        break;
                    case 'number-array':
                        if (values) {
                            children.push(builder.allFiltersWidget(filterWithValues(key, label, values)));
                        }
                        else {
                            children.push(builder.allFiltersWidget({
                                type: 'form.number',
                                key,
                                label,
                            }));
                        }
                        break;
                    case 'string':
                        if (values) {
                            children.push(builder.allFiltersWidget(filterWithValues(key, label, values)));
                        }
                        else {
                            children.push(builder.allFiltersWidget({
                                type: 'form.text',
                                key,
                                label,
                                emptyAsNull: true,
                            }));
                        }
                        break;
                    case 'string-array':
                        if (values) {
                            children.push(builder.allFiltersWidget(filterWithValues(key, label, values)));
                        }
                        else {
                            children.push(builder.allFiltersWidget({
                                type: 'form.text',
                                key,
                                label,
                                emptyAsNull: true,
                            }));
                        }
                        break;
                    case 'id':
                        children.push(builder.allFiltersWidget(filterWithValues(key, label, values)));
                        break;
                    case 'id-array':
                        children.push(builder.allFiltersWidget(filterWithValues(key, label, values)));
                        break;
                    case 'full-text-search':
                        children.push(builder.allFiltersWidget({
                            type: 'form.text',
                            key,
                            label,
                            emptyAsNull: true,
                        }));
                        break;
                }
            }
            return {
                key: '!customFilters', // This key can be used by other products to extend/modify account filters.
                label: filterPanelLabel,
                children: children.flatMap((child, index) => (index === 0 ? [child] : [{ type: 'form.divider' }, child])),
            };
        }
        else {
            return undefined;
        }
    }
    else {
        return undefined;
    }
}
function filterWithValues(key, label, values) {
    if (values && values.length <= 20) {
        return {
            type: 'form.checkboxList',
            key,
            label,
            values,
            style: {
                layout: '2-columns-stretch',
            },
        };
    }
    else {
        return {
            type: 'form.multiSelect',
            key,
            label,
            values: values ?? [],
        };
    }
}
